// extracted by mini-css-extract-plugin
module.exports = {"BladeCalculator":"blade_BladeCalculator__gX2_k"};